module.exports = __webpack_public_path__ + "static/media/logo-baby.4e223c65.png";